export default __webpack_public_path__ + "static/media/CAPABILITY_3DP.7a73d890.png";